import {WELL_HOVER_TYPE} from 'constants/dataEnum';
import PropTypes from 'prop-types';
import React from 'react';
import SBSectionNormalWells from './SBSectionNormalWells';
import SBSectionMixedWells from './SBSectionMixedWells';

function SpearBioLabware({ID, rowCount, colCount, wellStyle, wellHoverMode, hoveredWell, wellEventProps}) {
  const wellCommonProps = {hoveredWell, wellHoverMode};
  const sectionCommonProps = {labwareID: ID, wellStyle, rowCount, colCount};

  return (
    <>
      <SBSectionMixedWells
        {...sectionCommonProps} // eslint-disable-line react/jsx-props-no-spreading
        wellCommonProps={wellCommonProps}
        wellEventProps={wellEventProps}
      />
      <SBSectionNormalWells
        {...sectionCommonProps} // eslint-disable-line react/jsx-props-no-spreading
        wellCommonProps={wellCommonProps}
        wellEventProps={wellEventProps}
      />
    </>
  );
}

SpearBioLabware.propTypes = {
  ID: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  rowCount: PropTypes.number.isRequired,
  colCount: PropTypes.number.isRequired,
  wellStyle: PropTypes.object,
  wellHoverMode: PropTypes.oneOf(Object.values(WELL_HOVER_TYPE)),
  hoveredWell: PropTypes.object,
  wellEventProps: PropTypes.object,
};

SpearBioLabware.defaultProps = {
  wellStyle: {},
  wellHoverMode: WELL_HOVER_TYPE.BOTH,
  hoveredWell: {column: null, row: null, index: null},
  wellEventProps: {
    onMouseLeave: () => {},
    onClickWell: () => {},
    onMouseDown: () => {},
    onMouseEnter: () => {},
  },
};

export default SpearBioLabware;
